/* angular:styles/component:css;34f0b4cfe73f034e75efd227a5c2e257dd8a3f7da02c2176b89a039d5d4ca808;/app/src/app/shared/animations/country-code-picker-component.ts */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
.full-field {
  height: 48px;
  display: flex;
  justify-content: flex-start;
  gap: 8px;
}
.code-picker-box {
  width: 104px;
  height: 48px;
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
}
.code-picker-box:hover {
  border: 1px solid #dfdfdf !important;
  background: #fff;
}
.small-img {
  width: 16px;
  height: 16px;
}
.shown {
  border: 1px solid #dfdfdf;
  background: #fff;
}
.not-shown {
  background: #f2f2f2;
}
.phone-number-box {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  background: #f2f2f2;
  padding: 0 12px;
  overflow: hidden;
  border: 1px solid transparent;
}
.phone-number-box:hover {
  border: 1px solid #dfdfdf !important;
  background: #fff;
}
.phone-number-box:hover .phone-input {
  background: #fff;
}
.phone-number-box .phone-input:focus {
  background: #fff;
}
.phone-number-box:has(.phone-input:focus) {
  border: 1px solid #dfdfdf !important;
  background: #fff;
}
.phone-input {
  width: 100%;
  outline: none;
  border: none;
  margin: 0;
  color: #222;
  background: #f2f2f2;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.code-picker-list {
  width: 280px;
  background: #fff;
  border: 1px solid #dfdfdf;
  border-radius: 12px;
  padding: 16px 16px 0 16px;
  position: absolute;
  z-index: 10;
  left: -176px;
  overflow: hidden;
}
.placement-top-left {
  bottom: 52px;
  right: 0;
}
.placement-top-right {
  bottom: 52px;
  left: 0;
}
.placement-bottom-left {
  top: 52px;
  right: 0;
}
.placement-bottom-right {
  top: 52px;
  left: 0;
}
.search-bar {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  background: #f2f2f2;
  padding: 0 12px;
  overflow: hidden;
}
.search-bar:hover {
  border: 1px solid #dfdfdf;
  background: #fff;
}
.search-bar:hover .search {
  background: #fff;
}
.search-bar .search:focus {
  background: #fff;
}
.search-bar:has(.search:focus) {
  border: 1px solid #dfdfdf;
  background: #fff;
}
.search {
  width: 100%;
  outline: none;
  border: none;
  margin: 0;
  color: #222;
  background: #f2f2f2;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.search::placeholder {
  color: #a6a6a6;
}
.search-img {
  width: 24px;
  height: 24px;
  filter: brightness(0) saturate(100%) invert(65%);
}
.br-line {
  margin-top: 16px;
  margin-left: -16px;
  width: 120%;
  height: 1px;
  background: #dfdfdf;
}
.list-entries {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 13px;
  overflow-y: scroll !important;
  -ms-overflow-style: none;
  scrollbar-width: none;
  max-height: 373px;
}
.list-entries::-webkit-scrollbar {
  display: none;
}
.size-6-countries {
  height: 373px;
}
.size-5-countries {
  height: 295px;
}
.size-4-countries {
  height: 255px;
}
.country {
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: pointer;
}
.country:hover {
  opacity: 0.75;
}
.name {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 4px;
}
.black {
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
  color: #222;
}
.grey {
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin: 0;
  color: #5c5c5c;
}
.selected-country {
  display: inline-flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: not-allowed;
  width: 100%;
}
.selected {
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
  color: #a6a6a6;
}
.selected-12px {
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin: 0;
  color: #a6a6a6;
}
.info-text {
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}
.loading-start {
  opacity: 0;
}
.loading-false {
  opacity: 1 !important;
}
.red-img {
  filter: brightness(0) saturate(100%) invert(61%) sepia(69%) saturate(2913%) hue-rotate(318deg) brightness(89%) contrast(102%);
}
.noscroll {
}
/*# sourceMappingURL=country-code-picker-component.css.map */
